import { SystemsColors } from '../models/energy-analysis-system.model';
import { EconomicAnalisis, EconomicCurvesChart } from '../models/energy-analysis-task.model';

type EconomicDatasetGroup = NonNullable<EconomicAnalisis['result']>['datasetsGroups'][number];

/**
 * Builds a per-year chart (one series per system) from the NUMERIC_CURVE datasets of an economic analysis group.
 * Data rows are keyed by `categoryX` (year) and by system id; a missing value stays missing (never 0).
 * Labels are returned as resource ids, the caller translates them.
 */
export function buildEconomicCurvesChart(
  group: EconomicDatasetGroup | undefined,
  systemsColors: SystemsColors
): EconomicCurvesChart {
  const chart: EconomicCurvesChart = { series: [], data: [] };
  const rowsByYear = new Map<number, { [key: string]: number | string | null }>();
  group?.datasets
    ?.filter(dataset => dataset.type === 'NUMERIC_CURVE')
    .forEach(dataset => {
      chart.series.push({ id: dataset.id, label: dataset.name, color: systemsColors[dataset.id]?.value });
      chart.keyLabel = dataset.keyLabel;
      chart.keyUnit = dataset.keyUom;
      chart.valueLabel = dataset.valueLabel;
      chart.valueUnit = dataset.valueUom;
      Object.entries(dataset.data ?? {}).forEach(([key, value]) => {
        const year = parseFloat(key);
        const row = rowsByYear.get(year) ?? { categoryX: year };
        row[dataset.id] = value;
        rowsByYear.set(year, row);
      });
    });
  chart.data = [...rowsByYear.entries()].sort(([a], [b]) => a - b).map(([, row]) => row);
  return chart;
}
